const configuration = document.getElementById('theme-optional-components');

if (configuration) {
  const pending = new Map(Object.entries(JSON.parse(configuration.textContent || '{}')));
  const selector = [...pending.keys()].join(',');
  const load = (element) => {
    const url = pending.get(element.localName);
    if (!url) return;
    pending.delete(element.localName);
    import(url).catch((error) => console.warn('Optional theme component could not load:', element.localName, error));
  };
  const scan = (root) => {
    if (root instanceof Element && root.matches(selector)) load(root);
    root.querySelectorAll?.(selector).forEach(load);
  };
  if (selector) {
    scan(document);
    if (pending.size) {
      const observer = new MutationObserver((records) => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node instanceof Element) scan(node);
          }
        }
        if (!pending.size) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
}
